import "core-js/modules/es.array.concat";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.search";
import { redirectTo } from 'helpers/path';
import { PATH as SEARCH_PATH } from 'features/Search/Search.route'; // polyfill webpack require.ensure

if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};
export default (function () {
  var redirectToSearch = function redirectToSearch(nextState, replaceState, cb) {
    var url = "".concat(nextState.location.pathname).concat(nextState.location.search);
    var nextPath = url.replace(/^\/explore/, SEARCH_PATH);
    return redirectTo(nextPath)(nextState, replaceState, cb);
  };

  return {
    path: '/explore',
    onEnter: redirectToSearch,
    getIndexRoute: function getIndexRoute(location, callback) {
      require.ensure([], function () {
        callback(null, {
          onEnter: redirectToSearch
        });
      }, 'explore');
    },
    getChildRoutes: function getChildRoutes(location, callback) {
      require.ensure([], function () {
        callback(null, [{
          path: '*',
          onEnter: redirectToSearch
        }]);
      }, 'explore');
    }
  };
});